import { motion } from "framer-motion";
import React from 'react';

const Footer = ({ onLegalClick, setWaitlistOpen }) => {
  // 1) Split the text into an array of letters
  const letters = "Join Waitlist".split("");

  return (
    <footer className="bg-white">
      <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4 sm:space-y-2">
            <svg 
              className="w-36 sm:w-48" 
              viewBox="0 0 400 150" 
              xmlns="http://www.w3.org/2000/svg"
            >
              {/* Logo Mark */}
              <g transform="translate(50, 50)">
                <rect x="70" y="35" 
                      width="38" height="38" 
                      rx="12"
                      fill="none"
                      stroke="#7C3AED"
                      strokeWidth="2.5"
                      opacity="0.15"
                      transform="rotate(-15 89 54)"/>
                
                <rect x="81" y="15" 
                      width="38" height="38"
                      rx="12"
                      fill="none"
                      stroke="#7C3AED"
                      strokeWidth="2.5"
                      opacity="0.45"/>
                
                <rect x="92" y="35" 
                      width="38" height="38"
                      rx="12"
                      fill="none"
                      stroke="#7C3AED"
                      strokeWidth="2.5"
                      transform="rotate(15 111 54)"/>
              </g>
              
              <text x="190" y="105" 
                    fontFamily="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif" 
                    fontSize="42"
                    fontWeight="400"
                    textAnchor="start" 
                    fill="#7C3AED"
                    letterSpacing="-0.5">
                skillhub
              </text>
            </svg>
            <p className="text-gray-600">
              Transforming how the world learns.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-base font-semibold mb-4">Contact</h3>
            <div className="space-y-2 text-gray-600">
              <a href="mailto:contact@skill-hub.xyz" className="block hover:text-gray-900">
                contact@skill-hub.xyz
              </a>
            </div>
          </div>

          {/* Community */}
          <div>
            <h3 className="text-base font-semibold mb-4">Community</h3>
            <div className="space-y-2 text-gray-600">
              <motion.button
                onClick={() => setWaitlistOpen(true)}
                className="group relative inline-block font-bold text-purple-600 hover:text-purple-700"
                style={{ outline: "none", border: "none", background: "transparent" }}
              >
                {letters.map((letter, index) => (
                  <motion.span
                    key={index}
                    // 3) Each letter gets an animated 'press down' effect
                    initial={{ y: 0 }}
                    animate={{ y: [0, 5, 0] }} 
                    transition={{
                      delay: index * 0.1, // Stagger based on letter index
                      duration: 0.4,
                      repeat: Infinity,   // Repeat forever
                      repeatDelay: 1.5,   // Pause between each full cycle
                    }}
                    style={{ display: "inline-block", paddingRight: letter === " " ? "0.25rem" : undefined }}
                  >
                    {letter}
                  </motion.span>
                ))}
              </motion.button>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-base font-semibold mb-4">Legal</h3>
            <div className="space-y-2 text-gray-600">
              <button 
                onClick={() => onLegalClick('terms')}
                className="block w-full text-left hover:text-gray-900"
              >
                Terms of Service
              </button>
              <button 
                onClick={() => onLegalClick('privacy')}
                className="block w-full text-left hover:text-gray-900"
              >
                Privacy Policy
              </button>
              <button 
                onClick={() => onLegalClick('cookies')}
                className="block w-full text-left hover:text-gray-900"
              >
                Cookie Policy
              </button>
            </div>
          </div>
        </div>

        <div className="mt-8 sm:mt-12 text-center text-gray-600 text-sm">
          <p>&copy; 2025 SkillHub. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;